<template>
    <div class="sm:m-8 sm:max-w-md sm:w-full font-normal">
        <TransitionGroup name="list" tag="div" class="overflow-hidden space-y-2">
            <SingleTicker
                :ticker="ticker"
                v-for="event in eventTypes"
                :key="event.code"
                :event="event"
            />
        </TransitionGroup>
    </div>
</template>

<script>
import { tickersService } from "@/apps/ticker/services/tickers.service";
import SingleTicker from "@/views/tools/ticker/SingleTicker.vue";

export default {
    name: "vPopup",
    props: {
        ticker: Object,
    },
    data() {
        return {
            eventTypesAll: tickersService.getEventTypes(),
            eventTypes: [],
        };
    },
    mounted() {
        let index = 0;

        const addTicker = () => {
            const addInterval = setInterval(() => {
                if (index < this.eventTypesAll.length) {
                    this.eventTypes.push(this.eventTypesAll[index]);
                    index++;
                } else {
                    clearInterval(addInterval);
                }
            }, 300);
        };

        setTimeout(addTicker, 300);

        const removeTicker = () => {
            index = 0;
            const removeInterval = setInterval(() => {
                if (index < this.eventTypesAll.length) {
                    this.eventTypes.splice(0, 1);
                    index++;
                } else {
                    clearInterval(removeInterval);
                }
            }, 500);
        };

        setTimeout(removeTicker, 2500);

        setTimeout(() => {
            this.eventTypes = this.eventTypesAll;
        }, 6000);
    },
    components: {
        SingleTicker,
    },
};
</script>
